var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28369 11.8356C4.28369 12.5135 4.83325 13.0631 5.51117 13.0631H7.56317C8.24114 13.0631 8.79068 12.5135 8.79068 11.8356V10.915C8.79068 10.237 8.24114 9.6875 7.56317 9.6875H5.51117C4.83325 9.6875 4.28369 10.237 4.28369 10.915V11.8356Z",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6935 4.16304C11.6935 3.48512 11.1439 2.93555 10.466 2.93555H7.5737C6.89573 2.93555 6.34619 3.48512 6.34619 4.16304V5.08365C6.34619 5.76157 6.89573 6.31113 7.5737 6.31113H10.466C11.1439 6.31113 11.6935 5.76157 11.6935 5.08365V4.16304Z",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44946 11.3711H4.23078M8.82831 11.3711H13.5263",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.526 4.62893H11.7446M6.2688 4.62891H2.44946",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.20c7b90ef5d2aa346b95ee56d6431d63.svg";
export { ForwardRef as ReactComponent };